var SelectBox = (function () {

  var Utility = window.Utility;
  Utility.log('SelectBox.js loaded');
  var selectBoxClass = '.acr-select-box';
  var $selectBoxes = $(selectBoxClass);
  var selectOptionsClass = '.acr-select-box-options';
  var maxOptions = 10; // Default maximum number of options for non-scrollable dropdown.

  // @param scrollable: boolean - controls if we add the jquery scrollbar
  // @param callback (optional): function
  function init(nativeSelectId, scrollable, callback) {
    setUpListeners();
    // AR-12539. When we go to an article and return to the page, we want the
    // select options to return to previous values.
    setTimeout(function () {
      checkForInitialValue();
      if (scrollable) {
        makeScrollable(nativeSelectId, callback);
      } else if (typeof callback === 'function') {
        callback();
      }
    }, 500);
  }

  function setUpListeners() {
    $('html').on('click', function (e) {
      $(selectBoxClass).trigger('htmlClick', e);
    });

    $(selectBoxClass).each(function (i, el) {
      $(el).on('htmlClick', htmlClick);

      $('.acr-select-box-options ul li', $(el)).on('click', selectListOptionEvent);

      $('.acr-select-box-options svg', $(el)).on('click', clickCloseSVG);

      if (Utility.isIOS()) {
        // Workaround for Boostrap's own listener not working in IOS.
        $('.acr-select-box-button.collapsed', $(el)).on('click', function (e) {
          var $this = $(e.originalEvent.target);

          $this.removeClass('collapsed');
          $this.closest('.acr-select-box-wrapper').find('.acr-select-box-options').addClass('in');
        });
      }

      $('.acr-select-box-options').on('shown.bs.collapse', optionsShownEvent);
      $('.acr-select-box-options').on('hidden.bs.collapse', optionsHiddenEvent);
    });
  }

  function checkForInitialValue() {
    $(selectBoxClass).each(function (i, el) {
      var id = $(selectOptionsClass, $(el)).attr('id');
      if (id) {
        setInitialValue(id, Utility.getCookie(id));
      }
    });
  }

  function setInitialValue(id, value) {
    var $optionsElem = $('#' + id);
    var $options = $('li', $optionsElem);
    $options.removeClass('selected');

    // Find the span with the saved value and add class 'selected' to parent li.
    var $targetSpan = $('span[data-value="' + value + '"]', $options);
    $targetSpan.closest('li').addClass('selected');

    // Set the prompt to match the selected option
    var optionName = $targetSpan.html();
    var $selectBox = $targetSpan.closest(selectBoxClass);
    $('.select-box-prompt', $selectBox).html(optionName);
  }

  function htmlClick(evt, sourceEvt) {
    evt.stopPropagation();
    if (!thisOrChild(evt.target, sourceEvt.target)) {
      handleClickOutside(evt.target);
    }
  }

  function thisOrChild(elem, compElem) {
    if ((compElem === elem) || ($(compElem).parentsUntil(elem).parent()[0] === $(elem)[0])) {
      return true;
    }
    return false;
  }

  function handleClickOutside(selectBox) {
    collapseSelectOptions(selectBox);
  }

  function collapseSelectOptions(selectBox) {
    $(selectOptionsClass, $(selectBox)).collapse('hide');
  }

  function makeScrollable(nativeSelectId, callback /* optional */) {
    // console.log('[SelectBox.js] makeScrollable() nativeSelectId ' + nativeSelectId + '!');
    var $nativeSelect = $('select#' + nativeSelectId);
    var $parent = $nativeSelect.parent();
    var $cloneOptions = $nativeSelect
      .next('.acr-select-box-cloned')
      .find('.acr-select-box-options');

    $parent.one('selectBoxOptionShown', function () {
      // console.log('[SelectBox.js] makeScrollable(): selectBoxOptionShown evt fired!');
      $cloneOptions.addClass('scrollable').jScrollPane();
      // console.log('[SelectBox.js] makeScrollable(): select#' + nativeSelectId +
      //   ' now made scrollable.');
    });

    if (typeof callback === 'function') {
      callback();
    }
  }

  function selectListOptionEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    var parentSelectBoxOptions = $(e.target).closest(selectOptionsClass);
    var target = $('span', $(e.currentTarget));
    selectOption(parentSelectBox, parentSelectBoxOptions, target, true);
  }

  function selectOption(parentSelectBox, parentSelectBoxOptions, target, isUserClick) {
    var newVal = $(target).data('value');

    // Set input value
    $('input', $(parentSelectBox)).val(newVal);
    // Change selected option
    $('li', $(parentSelectBox)).removeClass('selected');
    $(target).parent().addClass('selected');
    $('.select-box-prompt', $(parentSelectBox)).html($(target).html());
    // Close select options
    collapseSelectOptions(parentSelectBox);

    if ($('input', $(parentSelectBox)).length > 0) {
      // save current select value state for return to page
      Utility.setCookie(parentSelectBoxOptions.attr('id'), newVal);
      // Notify parent that select change happened (so it can submit form / handle)
      notifyParentOfChange(parentSelectBox);
    }

    // If this is a clone of a native dropdown, and
    // custom-dropdown selection is by User-click (not by custom-code), then
    // Update native dropdown value with new selected value
    var $clone = target.closest('.acr-select-box-cloned');
    if ($clone.length > 0 && isUserClick) {
      updateNativeDropdown($clone, newVal);
    }
  }

  // only runs if there's an <input> in the parent container
  function notifyParentOfChange(parentSelectBox) {
    // Let the parent element know that a select option has changed
    // and pass it the input element with the new value.
    var inputElem = $('input', $(parentSelectBox))[0];
    var selectBoxName = inputElem.name;
    var selectBoxValue = inputElem.value;
    $(parentSelectBox).parent().trigger('selectBoxOptionChanged',
      inputElem, selectBoxName, selectBoxValue);
  }

  function clickCloseSVG(e) {
    e.stopPropagation();
    // console.log('$(".acr-select-box-options svg") clicked!  Closing custom dropdown.');
    var parentSelectBox = $(e.target).parentsUntil(selectBoxClass).parent();
    collapseSelectOptions(parentSelectBox);
  }

  function optionsShownEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    $(parentSelectBox).parent().trigger('selectBoxOptionShown', e);
  }

  function optionsHiddenEvent(e) {
    e.stopPropagation();
    var parentSelectBox = $(e.target).closest(selectBoxClass);
    $(parentSelectBox).parent().trigger('selectBoxOptionHidden', e);
  }

  // @param $clone: DOM element (the dropdown container)
  // @param newVal: string (the new dropdown value)
  var updateNativeDropdown = function ($clone, newVal) {
    var id = $clone.attr('data-id');
    var $nativeDropdown = $('#' + id);
    var onChangeEvent = null;
    // "new Event" throws error on IE
    try {
      onChangeEvent = new Event('change');
    } catch (error) {
      onChangeEvent = document.createEvent('Event');

      onChangeEvent.initEvent('change', false, false);
    }

    // update the native dropdown's value then trigger a change event
    $nativeDropdown.val(newVal);
    $nativeDropdown[0].dispatchEvent(onChangeEvent);
  };

  // this function is for replacing existing dropdowns with the non-native style
  // @param selector: css selector (the dropdown to be replaced)
  // @param maxOptionsOverride (optional): maximum nbr of options for a non-scrollable dropdown, if not 10
  // @param callback (optional): function to run after this method completes.
  // @param fontClass (optional): function to replace default font (acr-tab-small)
  var createSelect = function (selector, callback, fontClass) {
    // we'll need the ID to setup the bootstrap dropdowns
    var id = $(selector).attr('id');

    var defaultFontClass = 'acr-label-3';

    if (fontClass) {
      defaultFontClass = fontClass;
    }

    if (id) {
      var $dropdown = $(selector);

      // create a list of all the <option>s inside the select
      var itemList = returnList($dropdown);

      // find which <option> is selected
      var activeItem = $.grep(itemList, function (e) { return e.selected === 'selected'; });

      // if no <option> is selected default to first
      activeItem = (activeItem.length > 0) ? activeItem[0] : itemList[0];


      var template = '<div class="acr-select-box acr-select-box-cloned" data-id="' + id + '">'
          + '<div class="acr-select-box-top-wrapper">'
            + '<div class="acr-select-box-button collapsed" data-target="#' + id + '-clone" data-toggle="collapse" aria-expanded="false" aria-controls="' + id + '-clone">'
              + '<span class="select-box-prompt ' + defaultFontClass + '">' + activeItem.text + '</span>'
              + '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-down"></use></svg>'
            + '</div>'
          + '</div>'
          + '<div id="' + id + '-clone" aria-expanded="false" class="acr-select-box-options collapse">'
            + '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-down"></use></svg>'
            + '<ul>'
              + returnListAsString(itemList)
            + '</ul>'
          + '</div>'
        + '</div>';

      var newContainer = document.createElement('div');

      $dropdown.hide();

      // add our HTML to our placeholder div then inject into the page
      $(newContainer).html(template);
      $dropdown.after(template);

      // reinit so the asynchronously added dropdowns start working
      var scrollable = (itemList.length - 1 > maxOptions);
      init(id, scrollable, callback);
    }
  };

  // @param list: array of objects (list of value/text pairings for the <option> elements)
  var returnListAsString = function (list) {
    var string = '';

    for (var i = 0; i < list.length; i++) {
      string += '<li class="' + list[i].selected + '">';
      string += '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#checkmark"></use></svg>';
      string += '<span class="acr-paragraph-6" data-value="' + list[i].value + '">' + list[i].text + '</span></li>';
    }

    return string;
  };

  // @param element: DOM element (the native <select> being replaced)
  var returnList = function (element) {
    var items = [];

    $('option', element).each(function () {
      var thisItem = {
        value: $(this)[0].value,
        text: $(this).text(),
        selected: ($(this)[0].getAttribute('is-selected') === 'selected') ? 'selected' : '',
      };

      items.push(thisItem);
    });

    return items;
  };

  return {
    init: init,
    createSelect: createSelect,
    setInitialValue: setInitialValue,
    selectOption: selectOption,
  };
}());
